import React, { useEffect, useState } from 'react';
import axios from 'axios';

const CustomerList = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get('https://loyaltyprogram.navalsupermart.com/api/customers.php')
      .then(res => {
        setCustomers(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching customers:', err);
        setError('Failed to load customers');
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading customers...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div>
      <h2>Customer List</h2>
      <table border="1" cellPadding="8">
        <thead>
          <tr>
            <th>Photo</th> {/* 🆕 New column */}
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Points</th>
            <th>Created At</th>
          </tr>
        </thead>
        <tbody>
          {customers.length === 0 ? (
            <tr><td colSpan="7">No customers found.</td></tr>
          ) : (
            customers.map(c => (
              <tr key={c.id}>
                <td>
                  <img
                    src={c.photo_url || 'https://loyaltyprogram.navalsupermart.com/assets/default-avatar.png'}
                    alt="Customer"
                    width="60"
                    style={{ borderRadius: '6px', objectFit: 'cover' }}
                  />
                </td>
                <td>{c.id}</td>
                <td>{c.name}</td>
                <td>{c.email}</td>
                <td>{c.phone}</td>
                <td>{c.points_balance ?? 0}</td>
                <td>{c.created_at}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CustomerList;